export default class ItemTax {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_TAX='GET_HELPER_TAX';
  static SUCCESS_DATA='SUCCESS_DATA';
  static RESET_LIST='RESET_LIST';

  static submit(){
    return {
      type: ItemTax.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: ItemTax.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: ItemTax.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: ItemTax.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: ItemTax.DELETE_DATA
    };
  }
  static resetList() {
    return {
      type: ItemTax.RESET_LIST,
    };
  }
  static list(data) {
    return {
      type: ItemTax.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: ItemTax.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: ItemTax.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: ItemTax.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: ItemTax.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: ItemTax.GET_HELPER_TAX,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: ItemTax.ERROR_SERVER,
      payload: error
    };
  }
}